import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-valuation-cockpit-header',
  templateUrl: './valuation-cockpit-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ValuationCockpitHeaderComponent {}
